export const API_USER_DEACTIVATED = 'api.user.deactivated';
